import Card from '@mui/material/Card';
import {Box, CardContent, Typography, Link, useTheme} from '@mui/material';
import {useState} from 'react';
import {getRefEmbedded} from '@jobseeker/common-core/utils/refTrack';
import {Image} from '@jobseeker/lotus/components/Image';
import {ChevronRight} from '@jobseeker/lotus/icons';
export interface ArticleCardProps {
  title: string;
  description: string;
  imgUrl: string;
  logoUrl?: string;
  actionLabel: string;
  cover?: boolean;
  link: string;
  onClick?: () => void;
}
const isAppIimjobs = process.env.NEXT_PUBLIC_APP_NAME === 'iimjobs';

const ArticleCard = ({cover = true, ...props}: ArticleCardProps) => {
  const allowedParaLength = 450;
  const theme = useTheme();
  const [maxParaLength, setMaxParaLength] = useState<number>(allowedParaLength);
  const seeFullPara = () => {
    setMaxParaLength(props.description.length + 1);
  };
  const seeLessPara = () => {
    setMaxParaLength(allowedParaLength);
  };
  return (
    <Card variant="outlined" sx={{borderRadius: 4}}>
      <CardContent sx={{p: 0, '&:last-child': {paddingBottom: '0 !important'}}}>
        <Box sx={{display: 'flex', alignItems: 'center', gap: 1, p: 1.5}}>
          {props.logoUrl && (
            <Image
              width={54}
              src={props.logoUrl}
              style={{borderRadius: '12px', border: '1px solid #ddd'}}
            />
          )}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',

              flex: 1,
            }}
          >
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: 500,
              }}
            >
              {props.title}
            </Typography>
            <Link
              href={getRefEmbedded(props.link, 'SEARCH', 'normal')}
              target="_blank"
              {...(props.onClick && {onClick: props.onClick})}
              sx={{textDecoration: 'none', textDecorationColor: 'none'}}
            >
              <Typography
                component={'p'}
                sx={{
                  color: isAppIimjobs ? '#49966E' : '#e9630c',
                  fontSize: isAppIimjobs ? 12 : 14,
                  fontWeight: 500,
                }}
              >
                Explore the Office Culture&nbsp;
                <Image
                  src={ChevronRight}
                  alt={'right'}
                  width={12}
                  height={12}
                  style={{
                    verticalAlign: 'middle',
                  }}
                />
              </Typography>
            </Link>
          </Box>
        </Box>
        <Box
          component={Image}
          src={props.imgUrl}
          alt="Rounded Image"
          sx={{
            height: {lg: 300, md: 270, xxs: 200},
            margin: '0px 8px',
            borderRadius: 4,
            maxWidth: 'calc(100% - 16px)',
            width: isAppIimjobs ? 'calc(100% - 16px)' : 2000,
          }}
        />

        {props?.description && (
          <Box sx={{p: 1.5}}>
            <Typography fontSize={12} fontWeight={400}>
              {props.description?.slice(0, maxParaLength)}
              {props.description?.length > maxParaLength ? (
                <>
                  ...{' '}
                  <Link
                    onClick={isAppIimjobs ? seeLessPara : seeFullPara}
                    underline="none"
                    sx={{
                      cursor: 'pointer', // Ensures the pointer shows on hover
                    }}
                  >
                    Read More
                  </Link>
                </>
              ) : (
                allowedParaLength >= props.description?.length || (
                  <>
                    &nbsp;&nbsp;
                    <Link
                      onClick={seeLessPara}
                      underline="none"
                      sx={{
                        cursor: 'pointer', // Ensures the pointer shows on hover
                      }}
                    >
                      Read Less
                    </Link>
                  </>
                )
              )}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};
export default ArticleCard;
